import React from "react";
import ProductCardV2 from "./ProductCardV2";
import products from "./json/ProductGridData.json";
import { FiChevronDown } from "react-icons/fi";

const ProductGrid = () => {
  return (
    <div className="bg-gray-50 p-2">
      <div className="flex justify-center my-6">
        <FiChevronDown className="text-gray-500 text-3xl animate-bounce" />
      </div>
      <div className="text-center m-10">
        <h2 className="text-3xl md:text-5xl font-semibold relative inline-block">
          Telefonunu{" "}
          <span className="relative">
            Hemen
            <span className="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-red-500 via-purple-500 to-blue-500 rounded-full"></span>
          </span>{" "}
          Sat
        </h2>
      </div>

      <div className="w-full mx-auto">
        {/* Üstteki 2 Ürün - Dar Alan (max-w-4xl) */}
        <div className="max-w-4xl mx-auto p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            {products.slice(0, 2).map((product, index) => (
              <ProductCardV2 key={index} {...product} index={index} />
            ))}
          </div>
        </div>


        {/* Alttaki 3x3 Ürünler - Geniş Alan (max-w-6xl) */}
        <div className="max-w-6xl mx-auto p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {products.slice(2, 5).map((product, index) => (
              <ProductCardV2 key={index + 2} {...product} index={index + 2} />
            ))}
          </div>

          <div className="h-12"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {products.slice(5, 8).map((product, index) => (
              <ProductCardV2 key={index + 5} {...product} index={index + 5} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductGrid;
